import { CommonModule } from '@angular/common';
import {ChangeDetectorRef, Component, inject, OnInit, viewChild, ViewEncapsulation, HostListener} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import {ExamService} from "../../data-access/exam.service";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {ActivatedRoute, Router} from "@angular/router";
import {OutlineButtonComponent} from "../../../shared/ui/outline-button/outline-button.component";
import {FormsModule} from "@angular/forms";
import {FullButtonComponent} from "../../../shared/ui/full-button/full-button.component";
import {
  faFlag,
  faCircle,
  faCircleInfo,
  faXmark,
  faEye,
  faEyeSlash,
  faArrowRight, faArrowLeft, faTriangleExclamation
} from "@fortawesome/free-solid-svg-icons";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AudioPlaybackComponent} from "../../../shared/ui/problem-templates/audio-playback/audio-playback.component";
import {MultipleChoiceComponent} from "../../../shared/ui/problem-templates/multiplechoice/multiplechoice.component";
import {DecimalComponent} from "../../../shared/ui/problem-templates/decimal/decimal.component";
import {TextareaComponent} from "../../../shared/ui/problem-templates/textarea/textarea.component";
import _ from "lodash";
import {
  FullProblemTemplate
} from "../../../admin/feature/contentViewer/problemTemplatePreview/problemTemplatePreview.component";
import {MultifieldComponent} from "../../../shared/ui/problem-templates/multifield/multifield.component";
import {FormulaComponent} from "../../../shared/ui/problem-templates/formula/formula.component";
import {CountdownComponent, CountdownEvent} from "ngx-countdown";
import {Observable, of, switchMap} from "rxjs";
import {ConfirmDialogComponent, DIALOG_ACTION_STYLE} from "../../../shared/ui/confirm-dialog/confirm-dialog.component";
import {ComponentCanDeactivate} from "../../utils/pending-changes.guard";
import {Dialog} from "@angular/cdk/dialog";
import {TooltipDirective} from "../../../shared/ui/tooltip/tooltip.component";
import { MathjaxModule } from "mathjax-angular";
import {CodeEditorComponent} from "../../../shared/ui/code-editor/code-editor.component";
import { AudioRecordComponent } from "../../../shared/ui/problem-templates/audio-record/audio-record.component";
import { GroupingComponent } from "src/app/shared/ui/problem-templates/grouping/grouping.component";
import { FileUploadComponent } from "src/app/shared/ui/problem-templates/file-upload/file-upload.component";
import {Counter} from "@fortawesome/fontawesome-svg-core";
import {DotSpinnerComponent} from "../../../shared/ui/loaders/dot-spinner.component";

interface QuestionMenuItem {
  flag: boolean
  hasAnswer: boolean
}
export interface Question {
  question: FullProblemTemplate
  examquestion_id: number
  question_position: number
  response: number
  points_correct: number
  points_earned: number
  seconds_spent: number
  flag: boolean
  uuid: string
  lasttouched?: Date
}
export interface Parts {
  exampartinstance_id: number
  examinstance_id: number
  exampart_id: number
  part_position: number
  part_score: number
  available_score: number
  start_time: Date
  answer_time: Date
  due_time: Date
  details: {
    exampart_id: number
    exam_id: number
    part_name: string
    part_instructions: string
    part_duration_minutes: number
    questions_total: number
    continue_minutes?: number
  }
  questions: Question[]
  part_score_override?: number
}
export interface ExamPreviewResponse {
  details: {
    exam_id: number
    exam_title: string
    course_id: number
    attempts_max: number
    graded: boolean
    late_start: boolean
    late_finish: number
    user_id: number
    open: boolean
    active: boolean
    createdate: Date
    lastupdated: Date
  }
  exam_uuid: string
  mode: string
  examinstance_id: number
  parts: Parts[]
}
@Component({
    selector: 'exam-take',
    templateUrl: './exam-take.component.html',
  imports: [CommonModule, FontAwesomeModule, OutlineButtonComponent, FormsModule, FullButtonComponent, AudioPlaybackComponent, MultipleChoiceComponent, DecimalComponent, TextareaComponent, MultifieldComponent, FormulaComponent, CountdownComponent, TooltipDirective, CodeEditorComponent, AudioRecordComponent, GroupingComponent, FileUploadComponent, MathjaxModule, DotSpinnerComponent],
    styleUrls: ['./exam-take.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ExamTakeComponent implements ComponentCanDeactivate, OnInit {
  constructor(
    private examService: ExamService,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer
  ) {}
  router = inject(Router)
  // TODO remember about how each part has their own separate instructions
  instructions = false
  question = -1
  part = 0
  part_position = 0
  question_position = -1
  faFlag = faFlag
  faCircle = faCircle
  showPartInstructions = false
  examResponse: ExamPreviewResponse | null = null
  questionMenu: QuestionMenuItem[] = []
  examID = -1
  examUUID = ''
  isAnswerSaveLoading = false
  showQuestionAlertDialog = false
  showTimeDialog = false
  tempClusterJSON = JSON.stringify({})
  countdownConfig = {
    format: 'H:mm:ss',
    leftTime: 1
  }
  dialog = inject(Dialog);
  examBeingSubmitted = false
  hideCountdown = false
  isPreview = false
  resume = false
  display_part = 0
  disableSubmitButton = false
  showSurveyWarning = false
  isLoading = false
  isClassroom = false

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    $event.returnValue = true;
  }

  formatInstructions(html?: string | null): string {
    if (!html) {
      return ''
    }
    return html
      .replace(/&nbsp;/g, ' ')
      .replace(/<p>\s*<\/p>/gi, '<p><br></p>')
  }

  ngOnInit() {
    this.isClassroom = this.router.url.includes('assessment')
    this.route.queryParams.subscribe((params)  => {
      // TODO check if route is preview or take
      if(params['question']) {
        this.instructions = false
        this.question = Number(params['question'])
      } else {
        this.instructions = true
        this.question = -1
      }
      if(params['resume']) {
        this.resume = true
      }
      if(params['part']) {
        this.part_position = Number(params['part'])
        if(this.router.url.includes('preview') || !this.router.url.includes('question'))
          this.display_part = this.part_position
      } else if(params['start']) {
        this.part_position = 0
      }
      if(this.router.url.includes('preview') && !this.router.url.includes('question')) {
        this.isPreview = true
        this.part = this.part_position
        if(params['exam_id']) {
          this.examService.previewExam(params['exam_id']).subscribe((response) => {
            if(response.success) {
              this.examResponse = response.result
              // TODO make a function to handle exam response
              if(this.examResponse != null) {
                this.questionMenu = []
                this.createMenuItems(this.examResponse.parts[this.part_position].questions)
              }
              this.showPartInstructions = this.examResponse?.parts[this.part_position].details.part_instructions != null &&
                this.examResponse?.parts[this.part_position].details.part_instructions !== ""
              this.instructions = false
              if(!this.showPartInstructions) {
                this.nextPart()
              }
            } else {
              this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
            }
          })
        }
      } else {
        if(params['id'] || params['uuid']) {
          this.examID = params['id']
          this.examUUID = params['uuid']
          if(params['continue']) {
            this.continueExam(params['uuid'])
            this.display_part = 0
          } else if(params['start']) {
            this.isLoading = true
            this.examService.startExam(this.examID).subscribe((response) => {
              if(response.success) {
                this.examResponse = response.result
                this.examUUID = response.result.exam_uuid
                this.continueExam(response.result.exam_uuid)
              } else {
                this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
              }
              this.isLoading = false
            })
          } else if(!params['question']) {
            if(params['resume'] || params['uuid']) {
              this.examService.changeCanResumeToFalse(params['uuid']).subscribe((response) => {})
              this.resume = true
              this.isLoading = true
              this.examService.getLatestPartDetails(params['uuid']).subscribe((response) => {
                this.isLoading = false
                if (response.success) {
                  this.examResponse = response.result
                  this.display_part = 0
                  this.part_position = response.result.parts[0].part_position
                  this.instructions = this.examResponse?.parts[this.part].details.part_instructions != null &&
                    this.examResponse?.parts[this.part].details.part_instructions !== ""

                  if(this.examResponse != null && this.examResponse.parts[0].details.continue_minutes != null) {
                    this.countdownConfig = {
                      ...this.countdownConfig,
                      leftTime: Math.round(this.examResponse.parts[0].details.continue_minutes * 60)
                    }
                  } else if(this.examResponse != null && this.examResponse.parts[0].details.part_duration_minutes != null) {
                    this.countdownConfig = {
                      ...this.countdownConfig,
                      leftTime: Math.round(this.examResponse.parts[0].details.part_duration_minutes * 60)
                    }
                  }
                  if (!this.instructions) {
                    this.takeExam(this.part_position === 0 && !this.resume)
                  }
                } else {
                  this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
                }
              })
            } else {
              this.isLoading = true
              this.examService.getExamPartDetails(params['id']).subscribe((response) => {
                this.isLoading = false
                if (response.success) {
                  this.examResponse = response.result
                  //this.display_part = 0
                  this.instructions = this.examResponse?.parts[this.part].details.part_instructions != null &&
                    this.examResponse?.parts[this.part].details.part_instructions !== ""
                  if (!this.instructions) {
                    this.takeExam(this.part_position === 0 && !this.resume)
                  }
                } else {
                  this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
                }
              })
            }
          }
        }
      }
    })
  }

  continueExam(uuid: string) {
    if(!this.isPreview) {
      this.examBeingSubmitted = false

      this.isLoading = true
      this.examService.continueExam(uuid).subscribe((response) => {
        this.isLoading = false
        if(response.success) {
          this.examResponse = response.result
          this.examUUID = response.result.exam_uuid
          if(this.examResponse != null) {
            this.questionMenu = []
            this.createMenuItems(this.examResponse.parts[this.part].questions)
            this.part_position = this.examResponse.parts[this.part].part_position
          }
          if (response.result.parts.length >= 1) {
            this.part_position = response.result.parts[0].part_position
            if(response.result.parts[0].questions.length >= 1) {
              this.question_position = response.result.parts[0].questions[0].question_position
            }
            response.result.parts.forEach((part: any) => {
              part.questions.forEach((question: any) => {
                if ((question.question.type === 'RECORD_AUDIO' || question.question.type === 'UPLOAD_DOC') && question.question.recordedAnswer) {
                  this.getQuestionURL(part.part_position, question.question_position);
                }
              });
            });
          }

          if(this.examResponse != null && this.examResponse.parts[this.part].details.continue_minutes != null) {
            let continue_minutes = this.examResponse.parts[this.part].details.continue_minutes ?? 0

            this.countdownConfig = {
              ...this.countdownConfig,
              leftTime: Math.round(continue_minutes * 60)
            }
          } else if(this.examResponse != null && this.examResponse.parts[this.part].details.part_duration_minutes != null) {
            this.countdownConfig = {...this.countdownConfig, leftTime: Math.round(this.examResponse.parts[this.part].details.part_duration_minutes * 60)}
          }
          // TODO start countdown
        } else {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    } else {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {question: null, continue: true, start: null, part: this.part},
        queryParamsHandling: 'merge'
      })
    }
  }

  createMenuItems(questions: Question[]) {
    for(let question of questions) {
      this.questionMenu.push({
        flag: question.flag,
        hasAnswer: question.question != null && question.question.recordedAnswer != null
      })
    }
  }

  nextQuestion() {
    if (this.isCurrentSurveyUnanswered() && !this.isPreview) {
      this.showSurveyWarning = true
      return
    }
    // TODO check if question is at end of array
    // TODO also need to handle end of the part
    this.question += 1
    this.questionMenuSelection(this.question)
  }

  prevQuestion() {
    if(this.question !== 0) {
      this.question -= 1
      this.questionMenuSelection(this.question)
    }
  }

  tryNavigateToQuestion(index: number) {
    if (this.isCurrentSurveyUnanswered() && !this.isPreview) {
      this.showSurveyWarning = true
      return
    }
    this.questionMenuSelection(index)
  }

  questionMenuSelection(question: number) {
    this.showSurveyWarning = false
    // ngOnInit is being called again and thus the continue exam API is being called again
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {question: question, uuid: this.examUUID, continue: null, start: null},
      queryParamsHandling: 'merge'
    })
    if(this.examResponse != null)
      this.question_position = this.examResponse.parts[this.part].questions[question].question_position
    let top = document.getElementById('top');
    if(top !== null) {
      top.scrollIntoView()
      top = null
    }
  }

  takeExam(start?: boolean) {
    this.question_position = 0
    if(start)
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {part: this.part_position, question: 0, uuid: this.examUUID, start: true, continue: null, resume: null},
        queryParamsHandling: 'merge'
      })
    else
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {part: this.part_position, question: 0, uuid: this.examUUID, start: null, continue: true, resume: null},
        queryParamsHandling: 'merge'
      })
  }

  uploadAudioRecord(blob: Blob) {
    this.isAnswerSaveLoading = true
    this.examService.answerUpload(blob, this.examUUID, String(this.part_position), String(this.question_position)).subscribe((response) => {
      if (response.success) {
        this.recordAnswer(response.result)
      } else {
        this._snackBar.open('Your file could not be uploaded. ' + response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
      this.isAnswerSaveLoading = false
    })
    this.cdr.detectChanges();
  }

  uploadFileRecord(fileData: {name: string, file: File}) {
    this.isAnswerSaveLoading = true
    this.examService.answerUpload(fileData.file, this.examUUID, String(this.part_position), String(this.question_position)).subscribe((response) => {
      if (response.success) {
        this.recordAnswer(response.result)
      } else {
        this._snackBar.open('Your file could not be uploaded. ' + response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
      this.isAnswerSaveLoading = false
    })
  }


  getQuestionURL(partPosition: number, questionPosition: number) {
  this.examService.downloadAnswer(this.examUUID, partPosition, questionPosition).subscribe({
    next: (response: Blob) => {
      const url = URL.createObjectURL(response);

      const part = this.examResponse?.parts?.find(p => p.part_position === partPosition);
      if (!part) {
        console.error('Could not find part with part_position:', partPosition);
        return;
      }

      const question = part.questions?.find(q => q.question_position === questionPosition);
      if (!question) {
        console.error('Could not find question with question_position:', questionPosition);
        return;
      }

      question.question.recordedAnswer = url;
      this.cdr.detectChanges();
    },
    error: (err) => {
      console.error('Error downloading answer:', err);
    }
  });
}
  // This function should be called on change to automatically save the student's answer
  recordAnswer(value?: string) {
    if(!this.isPreview) {
      this.isAnswerSaveLoading = true
      this.examService.recordAnswer(this.examUUID, this.part_position, this.question_position, value).subscribe((response) => {
        if(response.success) {
          if(this.examResponse != null) {
            this.examResponse.parts[this.part].questions[this.question_position].lasttouched = new Date()
            this.examResponse.parts[this.part].questions[this.question_position].question.recordedAnswer = value
            if (this.examResponse.parts[this.part].questions[this.question_position].question.type === 'RECORD_AUDIO' || this.examResponse.parts[this.part].questions[this.question_position].question.type === 'UPLOAD_DOC') {
              this.getQuestionURL(this.part_position, this.question_position);
            }
          }
          this.questionMenu[this.question_position].hasAnswer = true
          this.showSurveyWarning = false
        } else {
          this._snackBar.open('Your answer could not be saved. ' + response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
        this.isAnswerSaveLoading = false
      })
    }
  }

  recordAnswerText(value?: string) {
    if(!this.isPreview) {
      this.isAnswerSaveLoading = true
      this.examService.recordAnswerText(this.examUUID, this.part_position, this.question_position, value).subscribe((response) => {
        if(response.success) {
          if(this.examResponse != null) {
            this.examResponse.parts[this.part].questions[this.question_position].lasttouched = new Date()
            if (this.examResponse.parts[this.part].questions[this.question_position].question.type === 'RECORD_AUDIO' || this.examResponse.parts[this.part].questions[this.question_position].question.type === 'UPLOAD_DOC') {
              this.getQuestionURL(this.part_position, this.question_position);
            }
          }
          this.questionMenu[this.question_position].hasAnswer = true
          this.showSurveyWarning = false
        } else {
          this._snackBar.open('Your answer could not be saved. ' + response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
        this.isAnswerSaveLoading = false
      })
      if(this.examResponse != null)
        this.examResponse.parts[this.part].questions[this.question_position].question.recordedAnswer = value
    }
  }

  submitPart() {
    if(!this.isPreview) {
      // TODO check if answers are filled and submit part, then the next part (if there is a next part) landing must be shown on successful submission
      // TODO this is for after the check
      if(this.examResponse != null && this.examResponse.parts[this.part].questions != null) {
        for(let question of this.examResponse.parts[this.part].questions) {
          if(question.question.recordedAnswer == null || question.question.recordedAnswer === '') {
            this.showQuestionAlertDialog = true
            return
          }
        }
      }
      this.forceSubmit()
    } else {
      // TODO check if reached end of parts for preview
      if(this.examResponse != undefined && this.examResponse?.parts.length > this.part_position+1) {
        this.part_position++
        this.part = this.part_position
        this.questionMenu = []
        this.createMenuItems(this.examResponse.parts[this.part_position].questions)
        this.showPartInstructions = this.examResponse?.parts[this.part_position].details.part_instructions != null &&
          this.examResponse?.parts[this.part_position].details.part_instructions !== ""
        this.instructions = false
        if(!this.showPartInstructions) {
          this.nextPart()
        }
      } else {
        this.router.navigate(['dashboard/exam/list']);
        this._snackBar.open('You have reached the end of this exam preview', 'Dismiss')
      }
    }
  }

  forceSubmit() {
    let tempPart = this.part_position
    if(this.examResponse)
      tempPart = this.examResponse.parts[0].part_position
    this.disableSubmitButton = true
	  this.examService.submitPart(this.examUUID, tempPart).subscribe((response) => {
      if (response.success) {
        if (this.examResponse != null && this.examResponse.parts.length - 1 > this.part) {
          this.showPartInstructions = true
        } else {
          if (response.msg === 'exam complete') {
            this._snackBar.open('Your exam has been submitted', 'Dismiss')
            this.router.navigate(['dashboard']);
          }
          // TODO reached the end of all the exam part
        }
        if (response.msg === 'next part prepared') {
          this.router.navigate([], {
            relativeTo: this.route,
            queryParams: {question: null, continue: null, start: null, part: this.part_position+1, uuid: this.examUUID},
            queryParamsHandling: 'merge'
          })
        }
        this.disableSubmitButton = false
      } else {
        // Do not navigate away here: students can't resume a placement exam on their own.
        this.examBeingSubmitted = false
        this.disableSubmitButton = false
        this._snackBar.open('Your submission did not go through. ' + response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
      }
      this.showQuestionAlertDialog = false
    })
    this.examBeingSubmitted = true
  }

  nextPart() {
    this.showPartInstructions = false
    this.takeExam()
  }

  isCurrentSurveyUnanswered(): boolean {
    if (!this.examResponse || this.question < 0)
      return false
    const question = this.examResponse.parts[this.part]?.questions[this.question]?.question
    return question?.problemtemplate_name?.includes('Survey') && question?.recordedAnswer == null
  }

  partHasUnansweredSurveyQuestions(): boolean {
    if (!this.isPreview) {
      if (!this.examResponse) return false
      const questions = this.examResponse.parts[this.part]?.questions
      if (!questions) return false
      return questions.some(question =>
        question.question?.problemtemplate_name?.includes('Survey') &&
        (question.question?.recordedAnswer == null || question.question?.recordedAnswer === '')
      )
    } return false;
  }

  toggleFlag(i: number) {
    // TODO need a API to save this flag in the DB
    if(this.questionMenu.length > i) {
      this.questionMenu[i].flag = !this.questionMenu[i].flag
    }
  }

  openTimeDetail() {
    this.showTimeDialog = true
  }

  calcDiffMin(date2: Date, date1: Date) {
    let diff = (new Date(date2).getTime() - new Date(date1).getTime()) / 1000
    diff /= 60
    if(diff < 0)
      return 0
    else
      return Math.abs(diff)
  }

  canDeactivate(): Observable<boolean> {
    if (this.countdownConfig.leftTime > 1 && !this.examBeingSubmitted) {
      const dialogRef = this.dialog.open<string>(ConfirmDialogComponent, {
        data: {
          title: 'Time Remaining Warning',
          message: 'You have time remaining on this exam part. By navigating away the timer will NOT stop. Refer to the datetime for when it is due. Please finish this part before navigating away.',
          button_actions: [
            {
              label: 'Exit',
              style: DIALOG_ACTION_STYLE.DANGER,
              action: () => 'Discard',
            },
            {
              label: 'Cancel',
              style: DIALOG_ACTION_STYLE.DEFAULT,
              action: () => 'Cancel',
            },
          ],
        },
        maxWidth: 500
      });

      return dialogRef.closed.pipe(
        switchMap((result) => {
          if (result === 'Discard') {
            return of(true);
          }
          return of(false);
        })
      );
    }
    return of(true);
  }

  checkForHTMLTags(test?: string): boolean {
    if(test != null)
      return /<\/?[a-z][\s\S]*>/i.test(test)
    else
      return false
  }

  exitExam() {
    // Will also need to check if it's a placement exam as well
    let tempPart = this.part_position
    if(this.examResponse)
      tempPart = this.examResponse.parts[0].part_position
    if(!this.isPreview) {
      this.examService.submitPart(this.examUUID, tempPart).subscribe((response) => {
        if(!response.success) {
          this._snackBar.open(response.msg, 'Dismiss', {panelClass: ['error-snackbar']})
        }
      })
    }
    this.isPreview ? this.router.navigate(['dashboard/exam/list']) : this.router.navigate(['dashboard']);
  }

  exitAssessment() {
    this.router.navigate(['dashboard']);
  }

  handleCountdownEvent(event: CountdownEvent) {
    console.log(this.examResponse?.parts[0].details)
    if(this.examResponse?.details.late_finish === 0 && event.action === 'done' && !this.isPreview && this.examUUID != null
      && (this.examResponse?.parts[0].details.part_duration_minutes != null || this.examResponse?.parts[0].details.continue_minutes != null)
      && this.examResponse?.parts[0].details.part_duration_minutes !== 0) {
      this.forceSubmit()
    }
  }

  protected readonly faCircleInfo = faCircleInfo;
  protected readonly faXmark = faXmark;
  protected readonly faEye = faEye;
  protected readonly faEyeSlash = faEyeSlash;
  protected readonly faArrowRight = faArrowRight;
  protected readonly faArrowLeft = faArrowLeft;
  protected readonly Array = Array;
  protected readonly JSON = JSON;
  protected readonly faTriangleExclamation = faTriangleExclamation;
}
